export const content = {
  background: {
    meta: 'Hintergrundbild',
  },
}
